export default {
  agency_key: '',
  mode: '',
  beian: '',
  beian_gn: '',


  chat_url: 'https://wpa.qq.com/msgrd?v=3&amp;uin=37362581&amp;site=qq&amp;menu=yes',
  address: '广州市番禺区番禺大道北383号1栋1304',
  uc_host: 'http://media.qianqiyunjia.cn',
  site_host: 'http://www.qianqiyunjia.cn',
  special_url: '/',
  site_title: '千企云家-软文精准营销平台',
  welcome_title: '千企云家 — 软文精准营销平台！',
  site_short_title: '千企云家',
  site_subtitle: '软文精准营销平台',
  company_name: '广州帝之都科技有限公司',
  copyright: '© 2019 广州帝之都科技有限公司',
  logo: 'http://www.qianqiyunjia.cn/images/logo.png',
  favicon: '',
  payment: '',
  qq: '37362581',
  tel: '18027368423',
  recharge_tel: '13580304168',
  company_account_id: '44048901040009717',
  company_bank: '中国农业银行广州宝岗大道支行',
  company_bank_name: '广州帝之都科技有限公司',
  alipay_account_id: '37362581@qq.com',
  alipay_name: '黄永金',
  alipay_pic: 'https://xinmeibao.oss-cn-hangzhou.aliyuncs.com/assets/image/qianqiyunjia_alipay.jpeg',
  wechat_pic: 'https://xinmeibao.oss-cn-hangzhou.aliyuncs.com/assets/image/qianqiyunjia_weixin.jpeg',
  section_id: 321739,
  belonger_id: 321739,
}



//////////////////
// WEBPACK FOOTER
// ./project_config.js
// module id = null
// module chunks = 